<template>
  <ul class="listing-filters-buttons-rounded">
    <li v-for="category in families" :key="category.id">
      <button
        class="listing-filters-buttons-rounded__button button-round-1"
        :class="{
          '--dark':
            selectedCategories.includes(category.id) ||
            (!selectedCategories.length && category.id === 'all'),
        }"
        @click="selectCategory(category.id)"
        :data-active="selectedCategories.includes(category.id)"
      >
        <span>{{ category.title }}</span>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ListingFiltersButtonsRounded',
}
</script>

<script setup>
const emit = defineEmits(['selected'])

const props = defineProps({
  families: Array,
})

const router = useRouter()
const route = useRoute()

// Inizializza le variabili reattive che conterranno le famiglie e le categorie di prodotti
const selectedOnLoad = route.query?.categories
  ? [].concat(route.query?.categories)
  : []

const selectedCategories = ref(selectedOnLoad)

watch(
  () => selectedCategories.value,
  (selectedCategories) => {
    router.push({
      query: {
        categories: selectedCategories,
      },
    })
    emit('selected', selectedCategories)
  }
)

// Definisce una funzione per selezionare o deselezionare una categoria
const selectCategory = async (id) => {
  if (id !== 'all') {
    // Set per garantire che ogni categoria sia unica
    const set = new Set(selectedCategories.value)

    // Se la categoria è già selezionata, la rimuove, altrimenti la aggiunge
    if (set.has(id)) {
      set.delete(id)
    } else {
      set.add(id)
    }

    selectedCategories.value = Array.from(set)
  } else {
    selectedCategories.value = []
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
